export default "__VITE_ASSET__7a2ed854__"